import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { driverVersions } from 'app/registries/consts/tabular-consts';

export const googleAdWordsAuthTypes = {
    UserAuthentication: 'UserAuthentication',
    ServiceAuthentication: 'ServiceAuthentication'
};

export enum apiTypes {
    GoogleAds = 'GoogleAds',
    GoogleAdWords = 'GoogleAdWords'
}

@Metamodel.model({
    name: 'GoogleAdWords',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.GoogleAdWords_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.GoogleAdWords_DisplayText)
    ]
})
export class GoogleAdWordsLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly CLIENT_CUSTOM_ID: IAttribute;
    public static readonly DEVELOPER_TOKEN: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly LOGIN_CUSTOMER_ID: IAttribute;
    public static readonly CLIENT_SECRET: IAttribute;
    public static readonly REFRESH_TOKEN: IAttribute;
    public static readonly EMAIL: IAttribute;
    public static readonly KEY_FILE_PATH: IAttribute;
    public static readonly PRIVATE_KEY: IAttribute;
    public static readonly TRUSTED_CERT_PATH: IAttribute;
    public static readonly API_VERSION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientCustomerId,
        association: 'CLIENT_CUSTOM_ID',
        templatable: true
    })
    public clientCustomerID?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DeveloperToken,
        association: 'DEVELOPER_TOKEN',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public developerToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        association: 'CLIENT_SECRET',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_RefreshToken,
        association: 'REFRESH_TOKEN',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public refreshToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.EmailLabel,
        association: 'EMAIL',
        templatable: true
    })
    public email?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_KeyFilePath,
        association: 'KEY_FILE_PATH',
        templatable: true
    })
    public keyFilePath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_PrivateKey,
        association: 'PRIVATE_KEY',
        templatable: true
    })
    public privateKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_TrustedCertPath,
        association: 'TRUSTED_CERT_PATH',
        templatable: true
    })
    public trustedCertPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseSystemTrustStore
    })
    public useSystemTrustStore?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_LoginCustomerId,
        association: 'LOGIN_CUSTOMER_ID',
        templatable: true
    })
    public loginCustomerID?: string;

    @Metamodel.attribute({
        display: stringResources.GoogleAdWords_AdsApiVersion_DisplayText,
        association: 'API_VERSION',
        templatable: true
    })
    public googleAdsApiVersion?: string;

    /** supportLegacyDataTypes is a readonly write-once property:
     * for all newly created LS, it is fixed to "false"
     * for existing LS, there are 2 cases:
     *  converted from "connectionProperties": supportLegacyDataTypes = true
     *  "oldResource" with API version: supportLegacyDataTypes = false
     */
    public supportLegacyDataTypes?: boolean;
    public apiType?: apiTypes = apiTypes.GoogleAds;
    public driverVersion?: driverVersions = driverVersions.Recommended;
    public isOldResource: boolean = false;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
